{
  "toast": {
    "unmarkedComplete": "Lesson unmarked as completed",
    "markedComplete": "Lesson marked as completed!",
    "statusError": "Error updating lesson status",
    "favoriteRemoved": "Removed from favorites",
    "favoriteAdded": "Added to favorites!",
    "favoriteError": "Error updating favorite",
    "ratingSent": "Rating submitted!",
    "ratingError": "Error submitting rating",
    "notesError": "Could not save your notes. Please try again.",
    "pdfLoaded": "PDF {{title}} loaded!",
    "assignmentSubmitted": "Assignment submitted successfully!"
  },
  "notFound": {
    "title": "Lesson not found",
    "description": "This lesson doesn't exist or you don't have access.",
    "back": "Back"
  },
  "progress": {
    "thisLesson": "This lesson",
    "course": "Course"
  },
  "sidebar": {
    "moduleLessons": "Module lessons",
    "close": "Close",
    "completedShort": "{{completed}}/{{total}} lessons completed",
    "completedLong": "{{completed}} of {{total}} lessons completed",
    "upNext": "Up next"
  },
  "content": {
    "assignmentInstructions": "Assignment instructions",
    "supportMaterials": "Supporting materials",
    "supportMaterialsDescription": "Download the files you need to complete this assignment",
    "submitSolution": "Submit your solution",
    "submitSolutionDescription": "Upload the files for your completed assignment",
    "aboutFiles": "About the files",
    "downloadFiles": "Files to download",
    "downloadFilesDescription": "Download the materials and resources for this lesson"
  },
  "live": {
    "title": "Live lesson",
    "scheduledFor": "Scheduled for {{date}}",
    "description": "This is a live lesson. Keep an eye on the schedule!",
    "join": "Join lesson"
  },
  "info": {
    "minutes": "{{minutes}} min",
    "lessonsProgress": "{{completed}}/{{total}} lessons ({{percent}}%)"
  },
  "actions": {
    "saving": "Saving...",
    "completed": "Completed",
    "complete": "Complete",
    "favorited": "Favorited",
    "favorite": "Favorite",
    "rated": "Rated",
    "rate": "Rate"
  },
  "rating": {
    "question": "How would you rate this lesson?",
    "cancel": "Cancel",
    "submit": "Submit"
  },
  "attachments": {
    "title": "Supporting material"
  },
  "navigation": {
    "previous": "Previous",
    "next": "Next"
  },
  "notes": {
    "title": "Notes",
    "saving": "Saving...",
    "saved": "Saved",
    "autosave": "Saved automatically",
    "placeholder": "Write your notes here..."
  },
  "locked": {
    "title": "Locked lesson",
    "description": "You don't have access to the course of this lesson yet.",
    "browse": "Browse courses"
  },
  "player": {
    "play": "Play",
    "pause": "Pause",
    "mute": "Mute",
    "unmute": "Unmute",
    "enterFullscreen": "Enter fullscreen",
    "exitFullscreen": "Exit fullscreen",
    "settings": "Settings",
    "speed": "Speed",
    "normal": "Normal",
    "quality": "Quality",
    "pip": "Picture-in-picture",
    "rewind": "Rewind {seektime}s",
    "fastForward": "Forward {seektime}s"
  },
  "stream": {
    "loading": "Loading video",
    "loadError": "Could not load the video.",
    "retry": "Try again",
    "playerTitle": "Lesson player",
    "resumeHere": "Keep watching here",
    "completesByWatching": "Completes as you watch",
    "watchToComplete": "Watch at least 90% of the video to complete the lesson."
  }
}
